export enum ParticipantPurpose {
  User = 'user',
  External = 'external',
  Agent = 'agent',
  Customer = 'customer',
  ACD = 'acd',
  IVR = 'ivr',
  VoiceMail = 'voicemail',
  Fax = 'fax',
  Group = 'group',
  Workflow = 'workflow'
}
